/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { Form, Input, Typography, Modal, Select, DatePicker, message, Upload, Button, Row, Col, Menu, Dropdown } from 'antd';
import { CameraOutlined, UploadOutlined, MoreOutlined } from '@ant-design/icons';
import moment from 'moment';
import { DataService } from '../../../config/dataService/dataService';
import { API_ENDPOINT, base64ToBlob, BLOOD_GROUPS, EMPLOYEE_TYPE, GENDERS } from '../../../config/config';
import { ImagePreview, CameraCapture, DesigSelector, ImageCropper } from '../../common';

const initialState = {
  name: '',
  father_name: '',
  cnic: '',
  contact: '',
  date_of_birth: null,
  blood_group_id: 3,
  is_biometric_verified: 1,
  is_police_verified: 1,
  emp_type: 1,
  gender_id: null,
  designation_id: null
};

const { Option } = Select;
const { Text } = Typography;

const FormDialog = ({ showDialog, disableOutSideCLose = false, isEdit = false, setReload, editId }) => {
  const [form] = Form.useForm();
  const [busy, setBusy] = useState(false);
  const [profilePicture, setProfilePicture] = useState(null);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [isImageChanged, setIsImageChanged] = useState(false);
  const [desigID, setDesigID] = useState(null)
  const [desigTitle, setDesigTitle] = useState(null)

  // State Variables
  const [isCropModalOpen, setIsCropModalOpen] = useState(false);
  const [tempImage, setTempImage] = useState(null); // Holds temporary image before saving

  const fetchEmployeeData = async (id) => {
    try {
      setBusy(true);
      const response = await DataService.post('/emp/get-by-id', { id });
      if (response.data.status) {
        const mData = response.data.data;
        form.setFieldsValue({
          ...mData,
          date_of_birth: moment(mData.date_of_birth),
          is_police_verified: Number(mData.is_police_verified),
          is_biometric_verified: Number(mData.is_biometric_verified),
        });

        setDesigTitle(mData.desig_title)
        setDesigID(mData.designation_id)


        const { profile_picture } = mData
        setProfilePicture(`${API_ENDPOINT}/${profile_picture}`)
        // setProfilePicture(require('../../../static/img/avatar/profileImage.png'));
      } else {
        message.error(response.data.message || response.message);
      }
      setBusy(false);
    } catch (error) {
      setBusy(false);
      console.error('Error fetching employee data:', error);
      message.error(error.message);
    }
  };

  const handleProceedClick = async () => {
    try {
      setShowConfirmation(false)
      const values = form.getFieldsValue();
      if (!profilePicture) return message.error('Please upload employee image first');
      setBusy(true);

      // Prepare form data
      const formData = new FormData();
      formData.append('name', values.name);
      formData.append('father_name', values.father_name);
      formData.append('cnic', values.cnic);
      formData.append('contact', values.contact);
      formData.append('date_of_birth', values.date_of_birth.format('YYYY-MM-DD'));
      formData.append('blood_group_id', values.blood_group_id);
      formData.append('is_biometric_verified', Number(values.is_biometric_verified));
      formData.append('is_police_verified', Number(values.is_police_verified));

      formData.append('designation_id', desigID);
      formData.append('gender_id', values.gender_id);
      formData.append('emp_type', values.emp_type);
      formData.append('isImageChanged', isImageChanged);

      // Add the profile picture if it exists
      if (isImageChanged) {
        const blob = await fetch(profilePicture).then(res => res.blob());
        const file = new File([blob], `cropped_image.png`, { type: "image/png" });
        formData.append('image_n', file);
        // const mimeType = profilePicture.split(',')[0].split(':')[1].split(';')[0]; // Extract MIME type from Base64 string
        // const imageBlob = base64ToBlob(profilePicture, mimeType);
        // formData.append('image_n', imageBlob, 'profile_picture.jpg'); // Assuming `profilePicture` is a `File` object
      }

      // Add `id` for editing if it's an update operation
      if (isEdit && editId) {
        formData.append('id', editId);
      }

      // Set the endpoint
      const endpoint = isEdit ? '/emp/update-request' : '/emp/create';

      // Submit the form data
      const response = await DataService.post(endpoint, formData, {
        headers: {
          'Content-Type': 'multipart/form-data', // Ensure multipart form data is correctly handled
        },
      });

      if (response.data.status) {
        message.success(response.data.message, () => {
          showDialog(false);
          setReload(true);
        });
      } else {
        setBusy(false);
        message.error(`Error: ${response.data.message}`);
      }
    } catch (error) {
      setBusy(false);
      message.error(`Error submitting data: ${error.message}`);
    }
  };

  useEffect(() => {
    if (isEdit && editId) {
      fetchEmployeeData(editId);
    }
  }, [isEdit, editId]);

  const validateCNIC = async (_, value) => {

    try {
      const cnicPattern = /^[0-9]{13}$/;
      if (!value) {
        return Promise.reject(new Error('CNIC is required!'));
      }
      if (!cnicPattern.test(value)) {
        return Promise.reject(new Error('CNIC must be exactly 13 digits and contain only numbers!'));
      }

      setBusy(true);

      const response = await DataService.post('/emp/validate-cnic-for-entry', { cnic: value, is_update: Boolean(isEdit) });
      setBusy(false);
      if (response.data.status) {
        return Promise.resolve();
      }

      return Promise.reject(new Error(response.data.message));

    } catch (error) {
      setBusy(false);
      // console.error('Error fetching employee data:', error);
      // message.error(error.message);
      return Promise.reject(new Error(error.message));
    }


  };

  const validateDOB = (_, value) => {
    const today = moment();
    if (!value) {
      return Promise.reject(new Error('Date of Birth is required!'));
    }
    if (today.diff(value, 'years') < 10) {
      return Promise.reject(new Error('Age must be at least 10 years old!'));
    }
    return Promise.resolve();
  };

  // Handle Image Upload
  const handleImageUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      setProfilePicture(e.target.result);
      setIsImageChanged(true);
    };
    reader.readAsDataURL(file);
    return false;
  };

  // Handle Image Context Menu
  const menu = (
    <Menu>
      <Menu.Item onClick={() => {
        if (profilePicture) {
          setIsImageModalOpen(true);
        }
      }}>Preview</Menu.Item>
      <Menu.Item onClick={() => {
        setProfilePicture(null);
        setIsImageChanged(true);
      }}>Remove</Menu.Item>
    </Menu>
  );

  return (
    <Modal
      open
      title={isEdit ? 'Edit Employee' : 'Register Employee'}
      okText={isEdit ? 'Update' : 'Create'}
      cancelText="Cancel"
      width="70%"
      confirmLoading={busy}
      // onCancel={() => showDialog(false)}
      // onOk={() => form.submit()}
      centered
      footer={[
        <Button key="cancel" onClick={() => showDialog(false)} disabled={busy}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={async () => {
          try {
            const result = await form.validateFields();
            if (!profilePicture) return message.error('Please upload employee image first');

            if (result) {
              setShowConfirmation(true)
            }
          } catch (error) {
            console.log('error', error)
          }
        }} disabled={busy}>
          {isEdit ? 'Update' : 'Create'}
        </Button>,
      ]}
      cancelButtonProps={{ disabled: busy }}
      destroyOnClose
    >
      <Modal
        open={showConfirmation}
        footer={null}
        centered
        onCancel={() => setShowConfirmation(false)}
        title="Confirmation Dialog"
      >
        <h5>
          please check each and everything before proceeding
        </h5>
        <div className='flex justify-end mt-30'>
          <Button onClick={() => setShowConfirmation(false)}>
            Close
          </Button>
          &nbsp;&nbsp;
          <Button raised type="primary" onClick={handleProceedClick}>
            Proceed
          </Button>
        </div>
      </Modal>

      {/* Enlarged Image Modal */}
      <ImagePreview
        visible={isImageModalOpen}
        imageSrc={profilePicture}
        onClose={() => setIsImageModalOpen(false)}
      />

      {/* Webcam Modal */}
      <CameraCapture
        visible={isCameraOpen}
        onCapture={(image) => {
          setProfilePicture(image);
          setIsImageChanged(true);
          setIsCameraOpen(false);
        }}
        onClose={() => setIsCameraOpen(false)}
      />

      {/* <WebCamDialog
        visible={webCamVisible}
        onClose={() => setWebCamVisible(false)}
        onCapture={handleCapture}
        pose={currentPose}// Change dynamically for each pose
      /> */}

      <div className="flex flex-col align-items-center">
        <div style={{ marginBottom: 10, position: "relative" }}>
          <Dropdown overlay={menu} trigger={["contextMenu", 'click']}>
            <img
              src={profilePicture || require("../../../static/img/avatar/profileImage.png")}
              alt="Profile"
              style={{ width: 110, height: 105, borderRadius: "50%", cursor: "pointer" }}
            />
          </Dropdown>
        </div>
        {/* <div style={{ marginBottom: 10 }}>
          <img
            src={profilePicture || require('../../../static/img/avatar/profileImage.png')}
            alt="Profile"
            style={{ width: 110, height: 105, borderRadius: '50%', cursor: 'pointer' }}
            onClick={() => {
              if (profilePicture) setIsImageModalOpen(true)
            }}
          />
        </div> */}
        <div className="flex mb-10">
          <Upload
            beforeUpload={handleImageUpload}
            // beforeUpload={(file) => {
            //   const reader = new FileReader();
            //   reader.onload = (e) => {
            //     setProfilePicture(e.target.result);
            //     setIsImageChanged(true); // Image has been changed
            //   };
            //   reader.readAsDataURL(file);
            //   return false; // Prevent auto upload
            // }}
            showUploadList={false}
          >
            <Button icon={<UploadOutlined />}>Upload Picture</Button>
          </Upload>
          <Button
            icon={<CameraOutlined />}
            style={{ marginLeft: 10 }}
            onClick={() => setIsCameraOpen(true)}
          >
            Take Picture
          </Button>
        </div>
      </div>
      <Form
        layout="horizontal"
        form={form}
        name="employee_form"
        labelAlign='left'
        onFinish={() => setShowConfirmation(true)}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 20 }}
        colon={false}
        disabled={busy}
        initialValues={initialState}
      >
        <Row gutter={20}>
          <Col span={12}>
            <Form.Item
              name="name"
              label="Name"
              rules={[{ required: true, max: 28, message: 'Please input the name!' }]}
            >
              <Input className='h-10' placeholder="Enter Name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="father_name"
              label="Father's Name"
              rules={[{ required: true, max: 28, message: 'Please input the father\'s name!' }]}
            >
              <Input className='h-10' placeholder="Enter Father\'s Name" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={20}>
          <Col span={12}>

            <Form.Item
              name="cnic"
              label="CNIC"
              rules={[{ validator: validateCNIC }]}
            >
              <Input className='h-10' placeholder="Enter CNIC" maxLength={13} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="contact"
              label="Contact"
              rules={[{ required: true, message: 'Please input the contact!' }]}
            >
              <Input className='h-10' placeholder="Enter Contact" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={20}>
          <Col span={12}>
            <Form.Item
              name="designation_id"
              label="Designation"
              rules={[
                {
                  required: true, validator: () => {
                    if (!desigID) {
                      return Promise.reject(new Error('Please select a designation!'));
                    }
                    return Promise.resolve();
                  }
                },
              ]}
            >
              <DesigSelector onItemSelected={setDesigID} defaultValue={desigTitle} />
            </Form.Item>
            {/* <Form.Item
              name="designation_id"
              label="Designation"
              rules={[{ required: true, message: 'Please select a designation!' }]}
            >
              <Select
                className="h-10"
                placeholder="Select Designation"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.children || '').toLowerCase().includes(input.toLowerCase())
                }
              >
                {SECURITY_COMPANY_DESIGNATION2S.sort((a, b) => a.label.localeCompare(b.label)).map((designation) => (
                  <Option key={designation.id} value={designation.id}>
                    {designation.label}
                  </Option>
                ))}
              </Select>
            </Form.Item> */}
          </Col>
          <Col span={12}>
            <Form.Item
              name="gender_id"
              label="Gender"
              rules={[{ required: true, message: 'Please select a gender!' }]}
            >
              <Select
                className="h-10"
                placeholder="Select Gender"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.children || '').toLowerCase().includes(input.toLowerCase())
                }
              >
                {GENDERS.map((designation) => (
                  <Option key={designation.id} value={designation.id}>
                    {designation.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={20}>
          <Col span={12}>
            <Form.Item
              name="date_of_birth"
              label="Date of Birth"
              rules={[{ validator: validateDOB }]}
            >
              <DatePicker className='h-10' style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="blood_group_id"
              label="Blood Group"
              rules={[{ required: true, message: 'Please select a blood group!' }]}
            >
              <Select className='h-10' placeholder="Select Blood Group">
                {BLOOD_GROUPS.map((group) => (
                  <Option key={group.id} value={group.id}>
                    {group.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={20}>
          <Col span={12}>
            <Form.Item name="is_biometric_verified" label="NADRA Verfied">
              <Select className='h-10'>
                <Option value={1}>Verified</Option>
                <Option value={0}>Not Verified</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="is_police_verified"
              label="Police Verified"
              rules={[{ required: true, message: 'Please select a employee type!' }]}
            >
              <Select className='h-10'>
                <Option value={1}>Verified</Option>
                <Option value={0}>Not Verified</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={20}>
          <Col span={12}>
            <Form.Item name="emp_type" label="Employee Type">
              <Select className='h-10'>
                {EMPLOYEE_TYPE.map((group) => (
                  <Option key={group.id} value={group.id}>
                    {group.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {isEdit && <Text className='text-orange-600 text-sm'>Caution:- If your update request gets approved then active ID card of the employee will be deactivated automatically !</Text>}
      </Form>
    </Modal>
  );
};

export default FormDialog;
